import { FormItem } from 'interfaces';
import { Input } from 'shared-components';

import { EMAIL_PATTERN, REQUIRED_MESSAGE } from './global';
import { FieldTypes } from './shared';

export const USER_EDITOR_FIELDS: FormItem[] = [
  {
    name: `email`,
    label: 'Email Address',
    type: FieldTypes.TEXT,
    required: true,
    component: Input,
    placeholder: 'Email Address',
    validation: {
      required: 'Required information missing please input Email address to continue',
      pattern: { message: 'Invalid email address', value: EMAIL_PATTERN },
    },
  },
  {
    name: `firstName`,
    label: 'First Name',
    placeholder: 'First Name',
    type: FieldTypes.TEXT,
    component: Input,
    className: '',
    required: true,
    validation: { required: REQUIRED_MESSAGE },
    fractionLength: 50,
  },
  {
    name: `lastName`,
    label: 'Last Name',
    placeholder: 'Last Name',
    type: FieldTypes.TEXT,
    component: Input,
    className: '',
    required: true,
    validation: { required: REQUIRED_MESSAGE },
    fractionLength: 50,
  },
];
